import { bindQueryParams } from "src/helpers/tools";
import { methods, request } from "./base";

const BcaApis = {
  /**
   * Save BCA (body composition) readings from device to backend.
   * Payload shape matches DeviceResultPage / setBcaResultRequest.
   */
  setBCAReadings: async (payload: Record<string, unknown>) =>
    await request({
      method: methods.POST,
      route: "/goal_readings/update_bca_readings",
      priv: true,
      payload,
    }),
  /**
   * Get paginated BCA sync logs for the patient.
   * Response: { data: { bca_logs: [], total_records: number } }
   */
  getBcaLogs: (payload: {
    queryParams?: { page?: number; limit?: string };
  }) => {
    const route = payload?.queryParams
      ? bindQueryParams("/patient/get_patient_bca_logs", payload.queryParams)
      : "/patient/get_patient_bca_logs";
    return request({
      method: methods.GET,
      route,
      priv: true,
    });
  },
  getBcaLogInfoById: (payload: { queryParams: { bcaLogId: string } }) => {
    const route = bindQueryParams(
      "/patient/get_patient_bca_info_by_id",
      payload.queryParams
    );
    return request({
      method: methods.GET,
      route,
      priv: true,
    });
  },
  /** Ranges for BCA parameters (for severity/color). Query: deviceType (e.g. "GoodFlip") */
  getBcaLifetronRanges: (payload: {
    queryParams?: { deviceType?: string };
  }) => {
    const route =
      payload?.queryParams && Object.keys(payload.queryParams).length > 0
        ? bindQueryParams("/helper/bca-ranges", payload.queryParams)
        : "/helper/bca-ranges";
    return request({
      method: methods.GET,
      route,
      priv: true,
    });
  },
};

export default BcaApis;
